import { render, staticRenderFns } from "./UserDescription.vue?vue&type=template&id=68b1ab1e&scoped=true&"
import script from "./UserDescription.vue?vue&type=script&lang=js&"
export * from "./UserDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b1ab1e",
  null
  
)

export default component.exports